import React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogDescription,
  DialogFooter,
  DialogFooterSpacer,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from '../../../components/Dialog'
import { MergeAccountsDialogViewModel } from './MergeAccountsDialogViewModel'

interface Props {
  vm: MergeAccountsDialogViewModel
}

export default observer(function MergeAccountsDialog({ vm }: Props) {
  return (
    <Dialog showing={vm.showing} onClose={vm.close}>
      <DialogHeader bordered>
        <DialogIllustration
          src={require('assets/images/img_create-flows.svg')}
          alt="Hands holding cards with checkboxes"
        />
        <DialogTitle>You're about to merge accounts</DialogTitle>
        <DialogDescription>
          Ensure that you have obtained valid certification from{' '}
          <strong>{vm.displayName}</strong>. Once merged, this action cannot be
          undone.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter bordered>
        <DialogFooterSpacer />
        <DialogButtonGroup>
          <DialogButton disabled={vm.link.pending} onClick={vm.close}>
            Close
          </DialogButton>
          <DialogButton
            disabled={vm.link.pending}
            type="primary"
            onClick={vm.link}
            loading={vm.link.pending}
          >
            Confirm Merge
          </DialogButton>
        </DialogButtonGroup>
      </DialogFooter>
    </Dialog>
  )
})
